import { IOffer } from '../types';
import { IOfferForAnalytic } from './tracking/types';

export const mapOfferForAnalytics = (offer: IOffer): IOfferForAnalytic => ({
  name: offer.offerName,
  description: offer.offerDescription,
  psk: offer.psk ? `${offer.psk.from} - ${offer.psk.to}` : null,
  payment: offer.monthlyPayment,
  rate: offer.rate,
  type: offer.type,
});

export const mapOffersListForAnalytics = (offers: IOffer[]): IOfferForAnalytic[] => offers.map(mapOfferForAnalytics);
